import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    this.timer = null;
  }

  submit() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    let controller = this;
    this.timer = setTimeout(() => {
      controller.element.requestSubmit();
    }, 800);
  }
}
